import { ErrorHandler, Injectable } from '@angular/core';
import { RumService, toError } from '@spotlight/shared/rum';
import { AnalyticsService } from '../analytics';

/**
 * Angular `ErrorHandler`: reports uncaught errors to Datadog RUM and sends the `Console Error Thrown`
 * Amplitude event. Angular catches these errors itself, so RUM's own error hooks never see them.
 * HTTP failures that `RumHttpErrorInterceptor` already reported are skipped.
 */
@Injectable()
export class ConsoleErrorHandlerService implements ErrorHandler {
  constructor(
    private readonly analytics: AnalyticsService,
    private readonly rum: RumService
  ) { }

  public handleError(error: unknown): void {
    const errorObj = toError(error);
    console.error(errorObj);
    if (!this.rum.isAlreadyReported(error)) {
      this.rum.addError(errorObj, { unhandled: true, severity: 'error' });
    }
    this.analytics.sendEvent(
      'Console Error Thrown',
      {
        error: errorObj.message || 'Undefined Error',
        stackTrace: errorObj.stack || 'Undefined Stack'
      }
    );
  }
}
